import { render, staticRenderFns } from "./default.vue?vue&type=template&id=3bbaf53c&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SideBar: require('/nvme_data/andreas/git/pcbarts/lenti/lenti_api/master/frontend/components/SideBar.vue').default,TopNavbar: require('/nvme_data/andreas/git/pcbarts/lenti/lenti_api/master/frontend/components/TopNavbar.vue').default})
